<template>
    <ResultCardContainer :header-title="t('results.blindStructure.cardTitle')">
        <FlexContainer
            :flex-direction="flexDirection.column"
        >
            <Typography
                :variant="typographyVariants.label"
                :weight="typographyWeights.regular"
                :color="typographyColors.greyMedium"
            >
                {{ t('results.blindStructure.table.caption') }}
            </Typography>
            <SpacingClassWrapper
                :padding-top="1"
            >
                <Typography
                    :variant="typographyVariants.body"
                    :weight="typographyWeights.regular"
                    :color="typographyColors.dark"
                    :size="typographySizes.title"
                >
                    {{ formFieldsData.blindLevel.submittedValue + ' minute'}}
                </Typography>
            </SpacingClassWrapper>
        </FlexContainer>
        <SpacingClassWrapper
            :padding-right="0"
            :margin-top="$mq | mq({ sm: 6, md: 6, pccFullSize: 4 })"
        >
            <TableScrollContainer
                :table-height-px="$mq | mq({
                    sm: 250,
                    md: 255
                })"
                :table-headers="tableHeaders"
                :scroll-visibility="scrollbarApperance.visible"
                :class="blindStructureTableClasses"
            >
                <tr
                    v-for="(item, index) in blindStructure"
                    :key="index"
                >
                    <SpacingClassWrapper :padding-bottom="lastChipElement(index) ? 0 : 4">
                        <SpacingClassWrapper :padding-right="2">
                            <TableCell
                                :variant="tableCellVariants.standard"
                                :text-align="tableCellAlign.left"
                            >
                                <Typography
                                    :variant="typographyVariants.caption"
                                    :weight="typographyWeights.regular"
                                    :transform="typographyTransform.capitalize"
                                >
                                    {{ item.smallBlind }}
                                </Typography>
                            </TableCell>
                            <TableCell
                                :variant="tableCellVariants.standard"
                                :text-align="tableCellAlign.left"
                            >
                                <Typography
                                    :variant="typographyVariants.caption"
                                    :weight="typographyWeights.regular"
                                >
                                    {{ item.bigBlind }}
                                </Typography>
                            </TableCell>
                        </SpacingClassWrapper>
                        <TableCell
                            :variant="tableCellVariants.standard"
                            :text-align="tableCellAlign.left"
                        >
                            <Typography
                                :variant="typographyVariants.caption"
                                :weight="typographyWeights.regular"
                            >
                                {{ item.time | convertToTime }}
                            </Typography>
                        </TableCell>
                    </SpacingClassWrapper>
                </tr>
            </TableScrollContainer>
        </SpacingClassWrapper>    
    </ResultCardContainer>
</template>

<script>
// Components
import Typography from '../../components/Typography';
import TableCell from '../../components/TableCell';

// Class Wrappers
import SpacingClassWrapper from '../../classWrappers/SpacingClassWrapper';

// Containers
import ResultCardContainer from '../../containers/results/ResultCardContainer';
import TableScrollContainer from '../../containers/generic/TableScrollContainer';
import FlexContainer from '../../containers/flex/FlexContainer';

// Types
import {
    typographyVariants,
    typographyColors,
    typographyWeights,
    typographyTransform,
    typographySizes
} from '../../types/Typography.types';
import { flexDirection, flexWrap } from '../../types/Flex.types';
import { scrollbarApperance, scrollbarApperanceDefault } from '../../types/ScrollFlex.types';
import { tableCellVariants, tableCellAlign } from '../../types/TableCell.types';

// Mixins
import styles from '../../mixins/styles.js';
import translations from '../../mixins/translations.js';

// Utils
import { convertToTime } from '../../utils/time-utils';

// Vuex
import { createNamespacedHelpers } from 'vuex';
const { mapGetters, mapState } = createNamespacedHelpers('pokerChipCalcModule');

export default {
    name: 'BlindStructureLayout',
    components: {
        // Components
        Typography,
        TableCell,
        // Class Wrappers
        SpacingClassWrapper,
        // Containers
        ResultCardContainer,
        TableScrollContainer,
        FlexContainer
    },
    filters: {
        convertToTime,
    },
    mixins: [styles, translations],
    data: function () {
        return {
            typographyVariants,
            typographyColors,
            typographyWeights,
            typographyTransform,
            typographySizes,
            flexDirection,
            flexWrap,
            scrollbarApperance,
            tableCellVariants,
            tableCellAlign
        }
    },
    computed: {
        ...mapState([
            'formFieldsData',
        ]),
        ...mapGetters([
            'blindStructure',
        ]),
        tableHeaders: function() {
            return [
                this.t('results.blindStructure.table.headers.smallBlind'),
                this.t('results.blindStructure.table.headers.bigBlind'),
                this.t('results.blindStructure.table.headers.time'),
            ]
        },
        blindStructureTableClasses: function () {
            return [
                this.cssClasses.pcc__blindStructure__table
            ]
        }
    },
    methods: {
        lastChipElement: function(currentIndex) {
            return this.blindStructure.length === currentIndex + 1;
        }
    }
};
</script>
